// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vN7yd","type":"styles_type__1DoHM","choices":"styles_choices__3-EZF"};